module.exports = __webpack_public_path__ + "img/index_logo.bb7822ed.png";